import $http from './http'
import config from './config'

export default {
    name: 'invoice',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getInvoiceList(data) {
        return $http.post(this.getUrl(`/InvoiceOrder/List`), data);
    },
    getInvoiceOrder(TaskID) {
        return $http.get(this.getUrl(`/InvoiceOrder/Details?TaskID=${TaskID}`));
    },
    saveInvoiceOrder(data) {
        return $http.post(this.getUrl(`/InvoiceOrder/Update`), data);
    },
    deleteInvoiceOrder(TaskID) {
        return $http.get(this.getUrl(`/InvoiceOrder/Delete?TaskID=${TaskID}`));
    },
    getInvoiceItemList(data) {
        return $http.post(this.getUrl(`/InvoiceItem/List`), data);
    },
    getInvoiceSplit(data) {
        return $http.post(this.getUrl(`/InvoiceOrder/InvoiceSplit`), data);
    },
    getInvoiceState(data) {
        return $http.post(this.getUrl(`/InvoiceOrder/InvoiceState`), data);
    },
    OrderLock(id){
        return $http.get(this.getUrl(`/InvoiceOrder/OrderLock?UniqueID=${id}`));
    },
    getInvoiceCostGroupBy(InvoiceID){
        return $http.get(this.getUrl(`/InvoiceOrder/InvoiceCostGroupBy?InvoiceID=${InvoiceID}`));
    },
    createSupplyOrder(taskId) {
        return $http.get(this.getUrl(`/InvoiceOrder/CreateSupplyOrder?taskId=${taskId}`));
    },
    confirmOrder(taskId) {
        return $http.get(this.getUrl(`/InvoiceOrder/ConfirmOrder?taskId=${taskId}`));
    },
    flushOrder(taskId) {
        return $http.get(this.getUrl(`/InvoiceOrder/FlushOrder?taskId=${taskId}`));
    },
    getDownloadUrl(taskId) {
        return $http.get(this.getUrl(`/InvoiceOrder/GetDownloadUrl?taskId=${taskId}`));
    },
}



// WEBPACK FOOTER //
// ./src/apis/invoiceApis.js